"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@remirror/react");
const Button_1 = __importDefault(require("../../../ui/Button/Button"));
const LinkOff_1 = __importDefault(require("@mui/icons-material/LinkOff"));
const getShortcutSymbol_1 = require("../../../utils/getShortcutSymbol");
const RemoveLinkButton = ({ inPopover = false }) => {
    const chain = (0, react_2.useChainedCommands)();
    const active = (0, react_2.useActive)();
    const disabled = !active.link() && !active.assetLink();
    const handleClick = () => {
        chain.removeLink().removeAssetLink().focus().run();
    };
    const handleShortcut = (0, react_1.useCallback)(() => {
        handleClick();
        // Prevent other key handlers being run
        return true;
    }, []);
    // when Shift+Ctrl+k is pressed show the modal, only registered in the toolbar button instance to avoid the key press
    // being double handled.
    if (!inPopover) {
        // disable the shortcut if the button is disabled
        (0, react_2.useKeymap)('Shift-Mod-k', disabled ? () => true : handleShortcut);
    }
    return (react_1.default.createElement(Button_1.default, { handleOnClick: handleClick, isActive: false, isDisabled: disabled, icon: react_1.default.createElement(LinkOff_1.default, null), label: `Remove link (Shift+${(0, getShortcutSymbol_1.getShortcutSymbol)()}+K)` }));
};
exports.default = RemoveLinkButton;
